import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DateTime } from 'luxon';

@Component({
	selector: 'app-credit-card-modal',
	templateUrl: './credit-card-modal.component.html',
	styleUrls: ['./credit-card-modal.component.scss']
})
export class CreditCardModalComponent implements OnInit {
	public expirationYears: any[] = [];
	public form: UntypedFormGroup;

	constructor(private _formBuilder: UntypedFormBuilder,
				public dialogRef: MatDialogRef<CreditCardModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any) {
	}

	ngOnInit(): void {
		for (let i = 0; i < 15; i++) {
			this.expirationYears.push(parseInt(DateTime.now().toFormat('yyyy'), 10) + i);
		}
		this.form = this._formBuilder.group({
			number: [null, [Validators.required, Validators.pattern(/^[0-9]+$/)]],
			expMonth: [null, Validators.required],
			expYear: [null, Validators.required],
			securityCode: [null, [Validators.required, Validators.pattern(/^[0-9]+$/)]],
			name: [null, Validators.required],
			address: [null, Validators.required],
			zip: [null, Validators.required],
			email: [''],
			emails: [[]]
		});
	}

}
